import { authRoles } from 'app/auth';
import EncompassLogin from './EncompassLogin';

const EncompassLoginConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false
        },
        toolbar: {
          display: false
        },
        footer: {
          display: false
        },
        leftSidePanel: {
          display: false
        },
        rightSidePanel: {
          display: false
        }
      }
    }
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: '/encompass-login',
      component: EncompassLogin
    }
  ]
};

export default EncompassLoginConfig;
